<div class="container">
  <app-terms-of-service #terms></app-terms-of-service>
</div>
